import type { App } from 'vue'
import PrimeVue from 'primevue/config'
import Aura from '@primeuix/themes/aura'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import AutoComplete from 'primevue/autocomplete'
import Button from 'primevue/button'
import Card from 'primevue/card'
import Checkbox from 'primevue/checkbox'
import Column from 'primevue/column'
import ConfirmDialog from 'primevue/confirmdialog'
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'
import Drawer from 'primevue/drawer'
import InputNumber from 'primevue/inputnumber'
import InputOtp from 'primevue/inputotp'
import InputText from 'primevue/inputtext'
import Message from 'primevue/message'
import MultiSelect from 'primevue/multiselect'
import ProgressBar from 'primevue/progressbar'
import ProgressSpinner from 'primevue/progressspinner'
import Select from 'primevue/select'
import Skeleton from 'primevue/skeleton'
import Slider from 'primevue/slider'
import Tag from 'primevue/tag'
import Textarea from 'primevue/textarea'
import Toast from 'primevue/toast'
import ToggleSwitch from 'primevue/toggleswitch'

export function installPrimeVue(app: App) {
  app.use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        darkModeSelector: '.marketal-dark',
        cssLayer: { name: 'primevue', order: 'theme, base, primevue, utilities' },
      },
    },
    ripple: true,
  })
  app.use(ToastService)
  app.use(ConfirmationService)
  const components = {
    AutoComplete, Button, Card, Checkbox, Column, ConfirmDialog, DataTable, Dialog, Drawer,
    InputNumber, InputOtp, InputText, Message, MultiSelect, ProgressBar, ProgressSpinner,
    Select, Skeleton, Slider, Tag, Textarea, Toast, ToggleSwitch,
  }
  Object.entries(components).forEach(([name, component]) => app.component(name, component))
}
